import React, { ReactNode } from 'react';
import { workerAppTypes } from 'components/EmployedsList';
import { StatusIndicator } from 'ui/StatusIndicator';
import {
  getWorkerAppStatus,
  workerAppStatusConfig,
  getFnsStatus,
  fnsStatusConfig,
} from 'utils/workerStatus';

interface WorkerStatusProps {
  workerApp: workerAppTypes | undefined;
  className?: string;
}

interface WorkerStatusWithIconProps extends WorkerStatusProps {
  positiveIcon: ReactNode;
  negativeIcon: ReactNode;
  isDeleted?: boolean;
}

export const WorkerAppStatusIndicator: React.FC<WorkerStatusProps> = ({
  workerApp,
  className,
}) => {
  const status = getWorkerAppStatus(workerApp);
  const { background, text } = workerAppStatusConfig[status];

  return <StatusIndicator background={background} text={text} className={className} />;
};

export const FnsStatusIndicator: React.FC<WorkerStatusProps> = ({
  workerApp,
  className,
}) => {
  const status = getFnsStatus(workerApp);
  const { background, text } = fnsStatusConfig[status];

  return <StatusIndicator background={background} text={text} className={className} />;
};

export const WorkerAppStatusWithIcon: React.FC<WorkerStatusWithIconProps> = ({
  workerApp,
  positiveIcon,
  negativeIcon,
  className,
  isDeleted,
}) => {
  const status = getWorkerAppStatus(workerApp, isDeleted);
  const { background, text } = workerAppStatusConfig[status];
  const isPositive = status === 'registered' && !isDeleted;

  return (
    <StatusIndicator
      background={background}
      text={text}
      icon={isPositive ? positiveIcon : negativeIcon}
      className={className}
    />
  );
};

export const FnsStatusWithIcon: React.FC<WorkerStatusWithIconProps> = ({
  workerApp,
  positiveIcon,
  negativeIcon,
  className,
}) => {
  const status = getFnsStatus(workerApp);
  const { background, text } = fnsStatusConfig[status];
  const isPositive = status === 'connected';

  const label =
    workerApp?.fns_status === 1
      ? 'Подключена без права оплаты налога'
      : workerApp?.fns_status === 2
      ? 'Подключена с правом оплаты налога'
      : text;

  return (
    <StatusIndicator
      background={background}
      text={label}
      icon={isPositive ? positiveIcon : negativeIcon}
      className={className}
    />
  );
};
